import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'catalog.loginPrompt.headline',
    defaultMessage: 'Already own a previous version of KOMPLETE or KONTAKT?',
  },
  body: {
    id: 'catalog.loginPrompt.body',
    defaultMessage:
      'See discounted updates, upgrade prices, and exclusive offers that you may be eligible for.',
  },
  cta: {
    id: 'catalog.loginPrompt.callToAction',
    defaultMessage: 'Login now',
  },
});
